// src/components/common/BetButton.jsx - Enhanced with animations
import React, { useState, useEffect } from 'react';
import { useBetSlip } from '../../context/BetSlipContext';
import { formatOddsValue } from '../../services/footballApi';

const BetButton = ({ 
    odds, 
    oddsFormat, 
    selection, 
    selectionName, 
    match, 
    matchId, 
    sport, 
    type,
    isCompact = false,
    disabled = false,
    onAddToBetslip
}) => {
    const { addToBetSlip, removeFromBetSlip, bets } = useBetSlip();
    const [isSelected, setIsSelected] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    
    // Check if this specific bet is already in the betslip
    useEffect(() => {
        const isInBetslip = bets.some(bet => 
            bet.matchId === matchId && 
            bet.selection === selectionName &&
            bet.marketType === type
        );
        setIsSelected(isInBetslip);
    }, [bets, matchId, selectionName, type]);
    
    const handleClick = (e) => {
        e.stopPropagation();
        
        if (disabled || !odds || odds === null) {
            return;
        }
        
        // Show feedback animation
        setShowFeedback(true);
        setTimeout(() => setShowFeedback(false), 1000);
        
        if (isSelected) {
            // Remove from betslip
            const betToRemove = bets.find(bet => 
                bet.matchId === matchId && 
                bet.selection === selectionName &&
                bet.marketType === type
            );
            if (betToRemove) {
                removeFromBetSlip(betToRemove.id);
            }
        } else {
            // Add to betslip
            const bet = {
                matchId: matchId,
                match: match,
                selection: selectionName,
                odds: parseFloat(odds),
                marketType: type,
                sport: sport,
                type: type
            };
            
            if (onAddToBetslip) {
                onAddToBetslip(odds, selectionName, selection, type);
            } else {
                addToBetSlip(bet);
            }
        }
    };
    
    if (disabled || !odds || odds === null) {
        return (
            <button 
                disabled
                className={`flex-1 bg-gray-800 text-gray-500 rounded-lg font-medium transition cursor-not-allowed ${
                    isCompact ? 'py-2 text-xs' : 'py-3 text-sm'
                }`}
            >
                -
            </button>
        );
    }
    
    const formattedOdds = formatOddsValue(odds, oddsFormat);
    
    return (
        <button
            onClick={handleClick}
            className={`
                flex-1 rounded-lg font-medium transition-all duration-200 transform relative overflow-hidden
                ${isCompact ? 'py-2 text-xs' : 'py-3 text-sm'}
                ${isSelected 
                    ? 'bg-green-600 text-white shadow-lg shadow-green-600/30 scale-105' 
                    : 'bg-gray-800 text-white hover:bg-green-600 hover:scale-105'
                }
                ${showFeedback ? 'animate-pulse' : ''}
            `}
        >
            <div className="flex flex-col items-center">
                <span>{formattedOdds}</span>
                {isSelected && (
                    <span className={`${isCompact ? 'text-[8px]' : 'text-[10px]'} opacity-80 mt-0.5 flex items-center gap-0.5`}>
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        Added
                    </span>
                )}
            </div>
            
            {/* Ripple effect on click */}
            {showFeedback && (
                <span className="absolute inset-0 bg-white opacity-20 animate-ripple" />
            )}
        </button>
    );
};

export default BetButton;